export const createSearchParams = ({ defaultSearchParams, filter }) => {
  let searchParams = { ...defaultSearchParams };

  if (filter) {
    searchParams = {
      ...defaultSearchParams,
      filter,
    };
  }

  return searchParams;
};
